// Validation error messages for forms
export const VALIDATION_MESSAGES = {
  // Required field messages
  VENDOR_NAME_REQUIRED: 'Vendor name is required',
  ZIP_CODE_REQUIRED: 'Please enter a ZIP code to search',
  EITHER_VENDOR_NAME_OR_ZIP_CODE: 'Either Vendor Name or ZIP code is required',
  EITHER_CITY_OR_STATE_REQUIRED: 'Either City or State is required',
  EITHER_ZIP_OR_CITY_AND_STATE: 'Either ZIP code or both City and State are required',
  STATE_REQUIRED: 'State is required',
  STATE_OR_ZIP_REQUIRED: 'State or ZIP code is required',
  VENDOR_SPECIALTY_REQUIRED: 'Vendor specialty is required',
  VENDOR_NAME_MIN_LENGTH: 'Vendor name must be at least 3 characters long',
  EITHER_VENDOR_NAME_OR_STATE_REQUIRED: 'Either Vendor Name or State is required',

  // Contract number validation messages
  CONTRACT_NUMBER_REQUIRED: 'Contract number is required',

  // Format validation messages
  API_ERROR_GENERIC: "Error occurred in the system. Please try again",
  FORM_FIELDS_REQUIRED: 'To Save, please complete the required fields',
  ZIP_CODE_INVALID: 'Please enter a valid US ZIP code',
  ZIP_CODE_NOT_FOUND: 'ZIP code not found. Please enter a valid US ZIP code',

  // General messages
  FIELD_REQUIRED: 'This field is required',
  INVALID_FORMAT: 'Invalid format',
  CITY_STATE_OR_ZIP_REQUIRED: 'Enter City and State or ZIP to search',


  // Contract specific messages
  VENDOR_TYPE_REQUIRED: 'Vendor type is required',
} as const;

// ZIP code to state mapping for US ZIP codes
export const ZIP_TO_STATE_MAP: Record<string, string> = {
  // Alabama: 35000-36999
  '35': 'AL', '36': 'AL',

  // Alaska: 99500-99999
  '995': 'AK', '996': 'AK', '997': 'AK', '998': 'AK', '999': 'AK',

  // Arizona: 85000-86999
  '85': 'AZ', '86': 'AZ',

  // Arkansas: 71600-72999, 75502-75505
  '716': 'AR', '717': 'AR', '718': 'AR', '719': 'AR',
  '720': 'AR', '721': 'AR', '722': 'AR', '723': 'AR', '724': 'AR', '725': 'AR',
  '726': 'AR', '727': 'AR', '728': 'AR', '729': 'AR',

  // California: 90000-96199
  '90': 'CA', '91': 'CA', '92': 'CA', '93': 'CA', '94': 'CA', '95': 'CA', '961': 'CA',

  // Colorado: 80000-81999
  '80': 'CO', '81': 'CO',

  // Connecticut: 06000-06999
  '06': 'CT',

  // Delaware: 19700-19999
  '197': 'DE', '198': 'DE', '199': 'DE',

  // Florida: 32000-34999
  '32': 'FL', '33': 'FL', '34': 'FL',

  // Georgia: 30000-31999, 39800-39999
  '30': 'GA', '31': 'GA', '398': 'GA', '399': 'GA',

  // Hawaii: 96700-96999
  '967': 'HI', '968': 'HI', '969': 'HI',

  // Idaho: 83200-83999
  '832': 'ID', '833': 'ID', '834': 'ID', '835': 'ID', '836': 'ID', '837': 'ID', '838': 'ID', '839': 'ID',

  // Illinois: 60000-62999
  '60': 'IL', '61': 'IL', '62': 'IL',

  // Indiana: 46000-47999
  '46': 'IN', '47': 'IN',

  // Iowa: 50000-52999
  '50': 'IA', '51': 'IA', '52': 'IA',

  // Kansas: 66000-67999
  '66': 'KS', '67': 'KS',

  // Kentucky: 40000-42999
  '40': 'KY', '41': 'KY', '42': 'KY',

  // Louisiana: 70000-71599
  '70': 'LA', '713': 'LA', '714': 'LA', '715': 'LA',

  // Maine: 03900-04999
  '039': 'ME', '040': 'ME', '041': 'ME', '042': 'ME', '043': 'ME', '044': 'ME', '045': 'ME', '046': 'ME', '047': 'ME', '048': 'ME', '049': 'ME',

  // Maryland: 20600-21999
  '206': 'MD', '207': 'MD', '208': 'MD', '209': 'MD',
  '20': 'MD', '21': 'MD',

  // Massachusetts: 01000-05599
  '01': 'MA', '02': 'MA', '055': 'MA',

  // Michigan: 48000-49999
  '48': 'MI', '49': 'MI',

  // Minnesota: 55000-56799
  '55': 'MN', '560': 'MN', '561': 'MN', '562': 'MN', '563': 'MN', '564': 'MN', '565': 'MN', '566': 'MN', '567': 'MN',

  // Mississippi: 38600-39799
  '386': 'MS', '387': 'MS', '388': 'MS', '389': 'MS',
  '390': 'MS', '391': 'MS', '392': 'MS', '393': 'MS', '394': 'MS', '395': 'MS', '396': 'MS', '397': 'MS',

  // Missouri: 63000-65999
  '63': 'MO', '64': 'MO', '65': 'MO',

  // Montana: 59000-59999
  '59': 'MT',

  // Nebraska: 68000-69999
  '68': 'NE', '69': 'NE',

  // Nevada: 89000-89999
  '89': 'NV',

  // New Hampshire: 03000-03899
  '030': 'NH', '031': 'NH', '032': 'NH', '033': 'NH', '034': 'NH', '035': 'NH', '036': 'NH', '037': 'NH', '038': 'NH',

  // New Jersey: 07000-08999
  '07': 'NJ', '08': 'NJ',

  // New Mexico: 87000-88499
  '87': 'NM', '880': 'NM', '881': 'NM', '882': 'NM', '883': 'NM', '884': 'NM',

  // New York: 10000-14999
  '10': 'NY', '11': 'NY', '12': 'NY', '13': 'NY', '14': 'NY',

  // North Carolina: 27000-28999
  '27': 'NC', '28': 'NC',

  // North Dakota: 58000-58999
  '58': 'ND',

  // Ohio: 43000-45999
  '43': 'OH', '44': 'OH', '45': 'OH',

  // Oklahoma: 73000-74999
  '73': 'OK', '74': 'OK',

  // Oregon: 97000-97999
  '97': 'OR',

  // Pennsylvania: 15000-19699
  '15': 'PA', '16': 'PA', '17': 'PA', '18': 'PA', '190': 'PA', '191': 'PA', '192': 'PA', '193': 'PA', '194': 'PA', '195': 'PA', '196': 'PA',

  // Rhode Island: 02800-02999
  '028': 'RI', '029': 'RI',

  // South Carolina: 29000-29999
  '29': 'SC',

  // South Dakota: 57000-57999
  '57': 'SD',

  // Tennessee: 37000-38599
  '37': 'TN', '380': 'TN', '381': 'TN', '382': 'TN', '383': 'TN', '384': 'TN', '385': 'TN',

  // Texas: 73300-73399, 75000-79999, 88500-88599
  '733': 'TX', '75': 'TX', '76': 'TX', '77': 'TX', '78': 'TX', '79': 'TX', '885': 'TX',

  // Utah: 84000-84999
  '84': 'UT',

  // Vermont: 05000-05999
  '05': 'VT',

  // Virginia: 20100-20199, 22000-24699
  '201': 'VA', '22': 'VA', '23': 'VA', '240': 'VA', '241': 'VA', '242': 'VA', '243': 'VA', '244': 'VA', '245': 'VA', '246': 'VA',

  // Washington: 98000-99499
  '98': 'WA', '990': 'WA', '991': 'WA', '992': 'WA', '993': 'WA', '994': 'WA',

  // West Virginia: 24700-26999
  '247': 'WV', '248': 'WV', '249': 'WV', '25': 'WV', '26': 'WV',

  // Wisconsin: 53000-54999
  '53': 'WI', '54': 'WI',

  // Wyoming: 82000-83199
  '82': 'WY', '830': 'WY', '831': 'WY',
};

// Function to get state from ZIP code
export const getStateFromZipCode = (zipCode: string): string | null => {
  if (!zipCode || zipCode.length !== 5) return null;

  // Try different prefix lengths (2, 3 digits)
  const prefixes = [
    zipCode.substring(0, 3),
    zipCode.substring(0, 2),
  ];

  for (const prefix of prefixes) {
    if (ZIP_TO_STATE_MAP[prefix]) {
      return ZIP_TO_STATE_MAP[prefix];
    }
  }

  return null;
};

// US ZIP code validation regex - matches 12345 format only
export const US_ZIP_CODE_REGEX = /^[0-9]{5}$/;

// validation regex for Alphanumeric characters
export const ALPHANUMERIC_REGEX = /^[a-zA-Z0-9]*$/;

// validation regex for Email addresses
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// numeric only regex
export const NUMERIC_ONLY_REGEX = /^((\(\d{3}\)-\d{3}-\d{4})|(\d{3}-\d{3}-\d{4})|(\d{10}))$/;

export const COUNTY_INPUT_REGEX = /^[a-zA-Z\s,]*$/;

export const ZIP_INPUT_REGEX = /^[0-9]*$/;
